import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-titulo-rotina',
  standalone: true,
  imports: [],
  templateUrl: './titulo-rotina.component.html',
  styleUrl: './titulo-rotina.component.css'
})
export class TituloRotinaComponent {
  @Input() titulo = '';
  @Input() subtitulo?: string;
  @Input() mostrarBotaoVoltar = true;
  @Input() iconeVoltar = './assets/icones/redesign/button/icon-back-title-button.svg';
  @Input() mostrarBotaoMenu = false;
  @Input() iconeMenu = './assets/icones/redesign/header/header-menu-open.svg';

  @Output() aoVoltar = new EventEmitter<void>();
  @Output() aoAbrirMenu = new EventEmitter<void>();

  clicarVoltar() {
    this.aoVoltar.emit();
  }

  clicarMenu() {
    this.aoAbrirMenu.emit();
  }
}
